import { render, staticRenderFns } from "./InviteAndUpdateAgent.vue?vue&type=template&id=2cc1306c&scoped=true&"
import script from "./InviteAndUpdateAgent.vue?vue&type=script&lang=js&"
export * from "./InviteAndUpdateAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1306c",
  null
  
)

export default component.exports